import * as React from "react";
import type { SVGProps } from "react";
const SvgFacebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.002 11.998a11.005 11.005 0 0 0 9.28 10.867v-7.688h-2.79v-3.179h2.794v-2.42a3.88 3.88 0 0 1 4.15-4.29c.826.014 1.65.087 2.464.22v2.705h-1.39a1.59 1.59 0 0 0-1.79 1.72v2.065h3.047l-.487 3.18h-2.56v7.687a11 11 0 0 0-2.291-21.85A11 11 0 0 0 1.002 11.998Z"
    />
  </svg>
);
export default SvgFacebookIcon;
